<template>
    <div id="kt_aside" class="aside aside-dark aside-hoverable"
         data-kt-drawer="true"
         data-kt-drawer-name="aside"
         data-kt-drawer-activate="{default: true, lg: false}"
         data-kt-drawer-overlay="true"
         data-kt-drawer-width="{default:'200px', '300px': '250px'}"
         data-kt-drawer-direction="start"
         data-kt-drawer-toggle="#kt_aside_mobile_toggle">
        <Brand />
        <AsideMenu :aside-content="asideContent"/>
    </div>
</template>

<script>
import Brand from "./Brand";
import AsideMenu from "./AsideMenu";
import menu from "../../Settings/menu";

export default {
    components: {
        Brand,
        AsideMenu,
    },

    data: _ => ({
        asideContent: [{
            title: "Dashboard",
            menus: menu
        }]
    })
}
</script>
